import Form from 'react-bootstrap/Form';
import { FormCheckType } from "react-bootstrap/FormCheck";
import React from "react";
import InfoButton from "../../InfoButton";
import {IntlMessageValue} from "../../../component/const/IntlMessage"; // Falls noch nicht importiert

type FormControlElement = HTMLInputElement | HTMLTextAreaElement;

interface UniChecksProps {
    /** Valid values: checkbox | radio | switch */
    type: FormCheckType | undefined;
    /** Label text for the element */
    label: string;
    /** Value of the element */
    value?: string;
    /** DOM ID */
    id?: string;
    /** Custom class name */
    class?: string;
    /** Disable the element */
    disabled?: boolean;
    /** Set the element as checked */
    checked?: boolean;
    /** Default value */
    defaultValue?: number;
    /** onChange handler */
    onChange?: React.ChangeEventHandler<FormControlElement>;
    name?: string;
    /** Show label before the input element */
    labelBefore?: boolean;
    /** Optional help tooltip */
    info?: {
        text: string;
        icon?: string;
    };
}

const UniChecks = (props: UniChecksProps) => {
    const ID = props.id ?? '';
    const baseClass = props.class ?? 'mb-3';
    const isReverse = props.labelBefore === true;
    const finalClass = `${baseClass} ${isReverse ? 'form-check-reverse' : ''}`.trim();

    return (
        <Form.Check
            type={props.type}
            id={ID}
            name={props.name}
            label={
                props.info ? (
                    <InfoButton.Wrapper>
                        <span>{props.label}</span>
                        <InfoButton
                            text={IntlMessageValue("",props.info.text,"")}
                            icon={props.info.icon ?? process.env.REACT_APP_INFOBUTTON_ICON ?? 'info'}
                        />
                    </InfoButton.Wrapper>
                ) : (
                    props.label
                )
            }
            value={props.value}
            disabled={props.disabled}
            defaultChecked={props.checked}
            defaultValue={props.defaultValue}
            onChange={props.onChange}
            className={finalClass}
        />
    );
};

export default UniChecks;
